import type { VueCompType } from 'virtual-vue';
import { WphkDesignComponent, type ClassToInterface } from '../../types/component';
import type { VModelProps } from '../hooks/use-v-model';

/** 标签索引 */
export type TabBarIndex = string | number;

/** 标签图标 */
export interface TaBarItemIcons {
  /** 激活态图标*/
  active: VueCompType;
  /** 未激活态图标*/
  inactive: VueCompType;
};

export class WphkDesignTabBar extends WphkDesignComponent implements VModelProps<TabBarIndex> {
  /** 当前选中标签的索引 - 仅vue3可用 */
  modelValue: TabBarIndex = '';
  /** 当前选中标签的索引 - 仅vue2可用 */
  value: TabBarIndex = '';
}

export type TabBarProps = ClassToInterface<WphkDesignTabBar>;

export enum TabBarItemBadgeType {
  /** 红点徽标 */
  Dot = 'dot',
  /** 数字徽标 */
  Number = 'number',
  /** 自适应胶囊徽标 */
  AutoCapsule = 'auto-capsule',
}

/** 红点徽标 */
export interface DotBadge {
  /** 徽标类型 */
  type: `${TabBarItemBadgeType.Dot}`;
}

/** 数字徽标 */
export interface NumberBadge {
  /** 徽标类型 */
  type: `${TabBarItemBadgeType.Number}`;
  /** 徽标内容 */
  text: string;
};

/** 自适应胶囊徽标 */
export interface AutoCapsuleBadge {
  /** 徽标类型 */
  type: `${TabBarItemBadgeType.AutoCapsule}`;
  /** 徽标内容 */
  text: string;
}

export class WphkDesignTabBarItem extends WphkDesignComponent {
  /** 徽标，红点徽标 ｜ 数字徽标 ｜ 自适应胶囊徽标 */
  badge?:  DotBadge | NumberBadge | AutoCapsuleBadge | undefined;
  /** 当前选中标签的索引 */
  index: TabBarIndex = '';
  /** 激活与未激活图标 */
  icons?: TaBarItemIcons;
}

export type TabBarItemProps = ClassToInterface<WphkDesignTabBarItem>;
